export const postScammer = async (params) => {

  try {
    const url = "https://users.ponzilover.com/api/scam_reports/";
    const response = await fetch(url, {
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST",
      body: JSON.stringify(params),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);

  }
  return null;
};
